import { render, staticRenderFns } from "./see_counsel.vue?vue&type=template&id=2efa9f7d&scoped=true&"
import script from "./see_counsel.vue?vue&type=script&lang=js&"
export * from "./see_counsel.vue?vue&type=script&lang=js&"
import style0 from "./see_counsel.vue?vue&type=style&index=0&id=2efa9f7d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efa9f7d",
  null
  
)

export default component.exports